import { DataExplorerAction } from '../actions/data-explorer/ActionTypes';
import * as Constants from '../constants';
import initialState from '../InitialState';
import { DataExplorer } from '../types/DataExplorer';
import {
  addResourceToTree,
  changeTreeState,
  convertResourcesToTree,
  deleteResourceFromTree,
  editResourceInTree
} from '../utils/DataExplorer';

const dataExplorerReducer = (
  state: DataExplorer = initialState.dataExplorer,
  action: DataExplorerAction
): DataExplorer => {
  switch (action.type) {
    case Constants.GET_ROOT_NODES:
      return {
        ...state,
        fetching: true,
        payload: {
          ...state.payload,
          activeNode: initialState.dataExplorer.payload.activeNode,
          activeNodeProperties: {
            ...state.payload.activeNodeProperties,
            payload: []
          }
        }
      };
    case Constants.ADD_NODE:
    case Constants.EDIT_NODE:
    case Constants.DELETE_NODE:
      return {
        ...state,
        fetching: true
      };
    case Constants.ADD_NODE_FAILED:
    case Constants.EDIT_NODE_FAILED:
    case Constants.DELETE_NODE_FAILED:
    case Constants.GET_ROOT_NODES_FAILED:
      return {
        ...state,
        fetching: false,
        failed: true
      };
    case Constants.GET_ROOT_NODES_SUCCESS:
      return {
        ...state,
        fetching: false,
        payload: {
          ...state.payload,
          explorerTree: convertResourcesToTree(action.payload.rootNodes)
        }
      };
    case Constants.ADD_NODE_SUCCESS:
      return {
        ...state,
        fetching: false,
        payload: {
          ...state.payload,
          explorerTree: addResourceToTree(
            state.payload.explorerTree,
            action.payload.node
          )
        }
      };
    case Constants.EDIT_NODE_SUCCESS:
      return {
        ...state,
        fetching: false,
        payload: {
          ...state.payload,
          explorerTree: editResourceInTree(
            state.payload.explorerTree,
            action.payload.node
          )
        }
      };
    case Constants.DELETE_NODE_SUCCESS:
      return {
        ...state,
        fetching: false,
        payload: {
          ...state.payload,
          explorerTree: deleteResourceFromTree(
            state.payload.explorerTree,
            action.payload.vmid
          )
        }
      };
    case Constants.EXPAND_NODE:
    case Constants.COLLAPSE_NODE:
    case Constants.GET_CHILD_NODES:
      return {
        ...state,
        payload: {
          ...state.payload,
          explorerTree: changeTreeState(
            state.payload.explorerTree,
            action.payload.vmid
          )
        }
      };
    case Constants.GET_CHILD_NODES_FAILED:
      return {
        ...state,
        failed: true
      };
    case Constants.GET_CHILD_NODES_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          explorerTree: changeTreeState(
            state.payload.explorerTree,
            action.payload.parentVmid,
            convertResourcesToTree(action.payload.childNodes)
          )
        }
      };
    case Constants.SELECT_NODE:
      return {
        ...state,
        payload: {
          ...state.payload,
          activeNode: action.payload.node
        }
      };
    case Constants.GET_NODE_PROPERTIES:
    case Constants.ADD_PROPERTY:
      return {
        ...state,
        payload: {
          ...state.payload,
          activeNodeProperties: {
            ...state.payload.activeNodeProperties,
            fetching: true
          }
        }
      };
    case Constants.GET_NODE_PROPERTIES_FAILED:
    case Constants.ADD_PROPERTY_FAILED:
      return {
        ...state,
        payload: {
          ...state.payload,
          activeNodeProperties: {
            ...state.payload.activeNodeProperties,
            fetching: false,
            failed: true
          }
        }
      };
    case Constants.GET_NODE_PROPERTIES_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          activeNodeProperties: {
            ...state.payload.activeNodeProperties,
            fetching: false,
            payload: action.payload.properties
          }
        }
      };
    case Constants.ADD_PROPERTY_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          activeNodeProperties: {
            ...state.payload.activeNodeProperties,
            fetching: false,
            payload: [
              ...state.payload.activeNodeProperties.payload,
              action.payload.property
            ]
          }
        }
      };
    default:
      return state;
  }
};

export default dataExplorerReducer;
